/**
 * User-facing sportsbook name. API data may use internal names (bet105, Betway (Alaska)).
 */
export function getSportsbookDisplayName(name) {
	if (!name) return name;
	if (name === 'ww_mains' || name === 'WagerWiz Mains') return 'WagerWiz';
	if (name === 'ww_props' || name === 'WagerWiz Props') return 'WagerWiz';
	if (name === 'Betway (Alaska)') return 'FanDuel';
	if (name === 'bet105') return 'Pinnacle';
	return name;
}

/** Alias for grouping / deduping books in tables and odds lists. */
export function normalizeSportsbookName(name) {
	return getSportsbookDisplayName(name);
}

/** Prefer canonical row when two alias names refer to the same book. */
export function shouldPreferSportsbookRow(candidate, existing) {
	if (existing === 'bet105' && candidate === 'Pinnacle') return true;
	if (existing === 'Betway (Alaska)' && candidate === 'FanDuel') return true;
	return false;
}

export function normalizeSportsbookList(books) {
	return [...new Set((books || []).map(getSportsbookDisplayName))];
}

export function mergePricesByDisplaySportsbook(prices) {
	const map = {};
	for (const price of prices || []) {
		const key = getSportsbookDisplayName(price.sportsbook);
		const existing = map[key];
		if (!existing || shouldPreferSportsbookRow(price.sportsbook, existing.sportsbook)) {
			map[key] = price;
		}
	}
	return map;
}

/**
 * Maps UI sportsbook selections to backend book names.
 * Pinnacle and bet105 are the same book under different names.
 */
export function resolveSportsbookValues(value) {
	if (value === 'FanDuel') {
		return ['Betway (Alaska)'];
	}
	if (value === 'ww_props') {
		return ['WagerWiz Props'];
	}
	if (value === 'ww_mains') {
		return ['WagerWiz Mains'];
	}
	if (value === 'WagerWiz') {
		return ['WagerWiz Props', 'WagerWiz Mains'];
	}
	if (value === 'Pinnacle' || value === 'bet105') {
		return ['Pinnacle', 'bet105'];
	}
	return [value];
}

export function pushSportsbooksToQueryField(queryRow, field, mkt) {
	for (const book of resolveSportsbookValues(mkt.value)) {
		if (!queryRow[field].includes(book)) {
			queryRow[field].push(book);
		}
	}
}
